// Native Vibration API only. iOS Safari / iOS PWA does not expose it, so haptics there
// are simply a no-op. Previous attempts to fake Taptic Engine ticks via hidden
// <input type="checkbox" switch> + label.click() caused click-event recursion through
// the GlobalHaptics capture listener, freezing dropdown selects and login buttons on
// Safari, and yanked focus toward the hidden element which made the fixed bottom nav
// jitter in iOS PWAs.

function userHapticDisabled(): boolean {
  try { return localStorage.getItem('wcfantasy.haptic') === 'off'; } catch { return false; }
}

function vibrate(pattern: number | number[]): void {
  if (userHapticDisabled()) return;
  if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') return;
  try { navigator.vibrate(pattern); } catch { /* ignore */ }
}

export const haptic = {
  light: () => vibrate(3),
  tap: () => vibrate(8),
  success: () => vibrate([6, 30, 12]),
  error: () => vibrate([20, 30, 20, 30, 20]),
  select: () => vibrate(4),
};
